/* eslint-disable max-len */
import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardHeader, CCardBody,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import WeaveTypeInputs from '../../components/WeaveTypeInputs/WeaveTypeInputs';
import { createWeaveTypeRequestAction } from '../../store/weaveType/weaveTypeActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateWeaveType = ({ createWeaveTypeRequest, isLoading, createWeaveTypeData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSubmit = (data) => {
    createWeaveTypeRequest({ data, navigate });
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/weavetype" onClick={(e) => { e.preventDefault(); navigate('/weavetype'); }}>
        {t('weaveType')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createWeaveType')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createWeaveType')}</h4></CCardHeader>
            <CCardBody>
              <WeaveTypeInputs
                onSubmit={handleSubmit}
                onCancel={() => navigate('/weavetype')}
                isLoading={isLoading}
                submitResponse={createWeaveTypeData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createWeaveTypeData: state.weaveTypeReducer.createWeaveTypeData,
});

export default connect(mapStateToProps, { createWeaveTypeRequest: createWeaveTypeRequestAction })(CreateWeaveType);
